import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M16 19C14.7866 19 13.6927 18.2691 13.2284 17.1481C12.764 16.027 13.0207 14.7367 13.8787 13.8787C14.7367 13.0207 16.027 12.764 17.1481 13.2284C18.2691 13.6927 19 14.7866 19 16C19 16.7956 18.6839 17.5587 18.1213 18.1213C17.5587 18.6839 16.7956 19 16 19ZM8 19C6.34315 19 5 17.6569 5 16C5 14.3431 6.34315 13 8 13C9.65685 13 11 14.3431 11 16C11 16.7956 10.6839 17.5587 10.1213 18.1213C9.55871 18.6839 8.79565 19 8 19ZM16 11C14.3431 11 13 9.65685 13 8C13 6.34315 14.3431 5 16 5C17.6569 5 19 6.34315 19 8C19 9.65685 17.6569 11 16 11ZM8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8C11 8.79565 10.6839 9.55871 10.1213 10.1213C9.55871 10.6839 8.79565 11 8 11Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "GridBigRound"
);
